import TreatmentI from '@interfaces/patients/treatmentI';
import { BaseStateI } from '@interfaces/redux/base-state';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getPatientTreatments } from '@services/patients/treatment';

export interface PatientTreatmentsState extends BaseStateI {
    patientTreatments: TreatmentI[] | null;
}

const fetchPatientTreatment = createAsyncThunk(
    'patient/fetchPatientTreatments',
    async (patientUsername: string, thunkAPI) => {
        const data = await getPatientTreatments(patientUsername);
        return data;
    }
);

const patientTreatmentsSlice = createSlice({
    name: 'patient-treatments',
    initialState: {
        error: null,
        patientTreatments: null,
        status: 'idle',
    } as PatientTreatmentsState,
    reducers: {
        resetPatient: (state) => {
            state.error = null;
            state.patientTreatments = null;
            state.status = 'idle';
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchPatientTreatment.pending, (state, action) => {
            state.status = 'loading';
        });
        builder.addCase(fetchPatientTreatment.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.error;
        });
        builder.addCase(fetchPatientTreatment.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.patientTreatments = action.payload;
        });
    },
});

export const { resetPatient } = patientTreatmentsSlice.actions;
export default patientTreatmentsSlice.reducer;
